import React, { Fragment, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Colors from '../../../Assets/Styles/Colors';
import { Box, Grid, IconButton, Typography, Tooltip, Zoom } from '@mui/material';
import BreadCrumbs from '../../../Components/BreadCrumbs/BreadCrumbs';
import {
  Person,
  Email,
  Phone,
  Sell,
  Business,
  InsertDriveFile,
  Article,
  AccessTime,
  DesignServices,
  Apartment,
  KeyboardArrowLeft,
  Link
} from '@mui/icons-material';
import { PrimaryButton } from '../../../Components/Buttons';
import { baseUrl } from '../../../../axios';
import AdProServices from '../../../Api/AdPro/AdProServices';

function AdProDetails() {
  const [copied, setCopied] = useState(false);
  const [fetching, setFetching] = useState(false);
  const { state } = useLocation();
  console.log("🚀 ~ AdProDetails ~ state:", state)
  const navigate = useNavigate();

  const copyContent = (text) => {
    const contentToCopy = text;
    navigator.clipboard.writeText(contentToCopy);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 500);
  }

  // const downloadFile = async (url, name) => {
  //   if (!url) {
  //     throw new Error("Resource URL not provided! You need to provide one");
  //   }
  //   setFetching(true);
  //   try {
  //     const response = await fetch(url);
  //     const file = response.blob();
  //     const blobURL = URL.createObjectURL(file);
  //     console.log("🚀 ~ .then ~ blobURL:", blobURL);
  //     const a = document.createElement("a");
  //     a.href = blobURL;
  //     a.style = "display: none";

  //     if (name && name.length) a.download = name;
  //     document.body.appendChild(a);
  //     a.click();
  //   } catch (e) {
  //     console.log(e)
  //   } finally {
  //     setFetching(false);
  //   }
  // }

  const downloadFile = async (url) => {
    setFetching(true);
    try {
      window.location.href = `${baseUrl}/api/ad/download?path=${url}`
    } catch (e) {
      console.error("Download failed:", e);
    } finally {
      setFetching(false);
    }
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        borderRadius: "12px",
      }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{
          background: Colors.primaryGradient,
          p: 2,
          borderRadius: "12px",
        }}
      >
        <Grid item xs={6}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <IconButton onClick={() => navigate(-1)}>
              <KeyboardArrowLeft sx={{ color: Colors.white }} />
            </IconButton>
            <Typography variant="body1" fontWeight="bold" sx={{ color: Colors.white }}>
              Adpro details
            </Typography>
          </Box>
        </Grid>
        <Grid
          item
          xs={6}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <BreadCrumbs currentPage={["Adpro details"]} />
        </Grid>
      </Grid>
      <Box
        sx={{
          backgroundColor: Colors.white,
          p: 2,
          borderRadius: "12px",
          boxShadow: "1px 1px 5px 1px #e2e2e2",
          mb: 2
        }}
      >
        <Box sx={{ p: 2, mb: 2 }}>
          <Typography sx={{ fontWeight: 600, fontSize: "22px" }}>
            User Details
          </Typography>
        </Box>
        <Grid container spacing={2}>
          <Grid item md={6}>
            <Box
              sx={{
                display: "flex",
                alignItem: "flex-start",
                gap: "8px",
                border: "1px solid #e2e2e2",
                borderRadius: "6px",
                p: 1
              }}
            >
              <Box sx={{ px: 1 }}>
                <Person />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px"
                }}
              >
                <Typography>
                  Name:
                </Typography>
                <Typography>
                  <Tooltip
                    title={copied && "copied"}
                    arrow
                    onClick={() => copyContent(state?.data?.name)}
                    TransitionComponent={Zoom}
                  >
                    {state?.data?.name}
                  </Tooltip>
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item md={6}>
            <Box
              sx={{
                display: "flex",
                alignItem: "flex-start",
                gap: "8px",
                border: "1px solid #e2e2e2",
                borderRadius: "6px",
                p: 1
              }}
            >
              <Box sx={{ px: 1 }}>
                <Email />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px"
                }}
              >
                <Typography>
                  Email:
                </Typography>
                <Typography>
                  <Tooltip
                    title={copied && "copied"}
                    arrow
                    onClick={() => copyContent(state?.data?.email)}
                    TransitionComponent={Zoom}
                  >
                    {state?.data?.email}
                  </Tooltip>
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item md={6}>
            <Box
              sx={{
                display: "flex",
                alignItem: "flex-start",
                gap: "8px",
                border: "1px solid #e2e2e2",
                borderRadius: "6px",
                p: 1
              }}
            >
              <Box sx={{ px: 1 }}>
                <Phone />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px"
                }}
              >
                <Typography>
                  Phone:
                </Typography>
                <Typography>
                  <Tooltip
                    title={copied && "copied"}
                    arrow
                    onClick={() => copyContent(state?.data?.phoneNumber)}
                    TransitionComponent={Zoom}
                  >
                    {state?.data?.phoneNumber}
                  </Tooltip>
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item md={6}>
            <Box
              sx={{
                display: "flex",
                alignItem: "flex-start",
                gap: "8px",
                border: "1px solid #e2e2e2",
                borderRadius: "6px",
                p: 1
              }}
            >
              <Box sx={{ px: 1 }}>
                <Business />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px"
                }}
              >
                <Typography>
                  Company:
                </Typography>
                <Typography>
                  {state?.data?.companyName}
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item md={6}>
            <Box
              sx={{
                display: "flex",
                alignItem: "flex-start",
                gap: "8px",
                border: "1px solid #e2e2e2",
                borderRadius: "6px",
                p: 1
              }}
            >
              <Box sx={{ px: 1 }}>
                <Apartment />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px"
                }}
              >
                <Typography>
                  Industry:
                </Typography>
                <Typography>
                  {state?.data?.industry?.name ?? "-"}
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item md={6}>
            <Box
              sx={{
                display: "flex",
                alignItem: "flex-start",
                gap: "8px",
                border: "1px solid #e2e2e2",
                borderRadius: "6px",
                p: 1
              }}
            >
              <Box sx={{ px: 1 }}>
                <DesignServices />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px"
                }}
              >
                <Typography>
                  Service:
                </Typography>
                <Typography>
                  {state?.data?.service?.name ?? "-"}
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item md={6}>
            <Box
              sx={{
                display: "flex",
                alignItem: "flex-start",
                gap: "8px",
                border: "1px solid #e2e2e2",
                borderRadius: "6px",
                p: 1
              }}
            >
              <Box sx={{ px: 1 }}>
                <Sell />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px"
                }}
              >
                <Typography>
                  Budget:
                </Typography>
                <Typography>
                  PKR {state?.data?.budget}
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item md={6}>
            <Box
              sx={{
                display: "flex",
                alignItem: "flex-start",
                gap: "8px",
                border: "1px solid #e2e2e2",
                borderRadius: "6px",
                p: 1
              }}
            >
              <Box sx={{ px: 1 }}>
                <AccessTime />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px"
                }}
              >
                <Typography>
                  Timeline:
                </Typography>
                <Typography>
                  {state?.data?.timeline}
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item md={6}>
            <Box
              sx={{
                display: "flex",
                alignItem: "flex-start",
                gap: "8px",
                border: "1px solid #e2e2e2",
                borderRadius: "6px",
                p: 1,
              }}
            >
              <Box sx={{ px: 1 }}>
                <Article />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px"
                }}
              >
                <Typography>
                  Detail:
                </Typography>
                <Typography>
                  {state?.data?.details}
                </Typography>
              </Box>
            </Box>
          </Grid>
          {state?.data?.file && (
            <Grid item md={6}>
              <Box
                sx={{
                  display: "flex",
                  alignItem: "flex-start",
                  gap: "8px",
                  border: "1px solid #e2e2e2",
                  borderRadius: "6px",
                  p: 1
                }}
              >
                <Box sx={{ px: 1 }}>
                  <InsertDriveFile />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px"
                  }}
                >
                  <Typography>
                    File:
                  </Typography>
                  <PrimaryButton
                    loading={fetching}
                    title={"Download"}
                    onClick={() => downloadFile(state?.data?.file)}
                  />
                </Box>
              </Box>
            </Grid>
          )}
          {state?.data?.links && (
            <Grid item md={12}>
              <Box
                sx={{
                  display: "flex",
                  alignItem: "flex-start",
                  gap: "8px",
                  border: "1px solid #e2e2e2",
                  borderRadius: "6px",
                  p: 1
                }}
              >
                <Box sx={{ px: 1 }}>
                  <Link />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px"
                  }}
                >
                  <Typography>
                    Link:
                  </Typography>
                  <Typography>
                    {state?.data?.links}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          )}
        </Grid>
      </Box>
    </Box>
  )
}

export default AdProDetails